import { Box } from '@hover/blueprint';
import type { ReactNode } from 'react';
import React from 'react';

const Main = ({ children }: { children: ReactNode }) => (
  <Box
    backgroundColor="neutral.0"
    display="block"
    id="main"
    overflowY={{ base: 'scroll', tablet: 'unset' }}
    paddingTop="env(safe-area-inset-top)"
  >
    {children}
  </Box>
);

export { Main };
